<template slot="block-content">
  <el-row>
    <integration-card :integration="Integrations.crowdtwist" />
    <integration-card :integration="Integrations.segment" />
    <integration-card :integration="Integrations.optimove" />
    <integration-card :integration="Integrations.activedirectory" />
    <integration-card :integration="Integrations.kochava" />
    <integration-card :integration="Integrations.sftp" />
    <integration-card :integration="Integrations.gcs" />
    <integration-card :integration="Integrations.s3" />
    <integration-card :integration="Integrations.sbtech" />
    <integration-card :integration="Integrations.shopify" />
    <integration-card :integration="Integrations.magento" />
    <integration-card :integration="Integrations.salesforce" />
    <integration-card :integration="Integrations.mixpanel" />
    <integration-card :integration="Integrations.tglab" />
    <integration-card :integration="Integrations.lithium" v-if="showLithium" />
    <integration-card :integration="Integrations.betsson" v-if="showBetsson" />
    <integration-card :integration="Integrations.oasis" v-if="showOasis" />
    <integration-card
      :integration="Integrations.lithiumv2"
      v-if="showLithiumV2"
    />
    <integration-card :integration="Integrations.webhook" />
    <integration-card
      :integration="Integrations.sportradar"
      v-if="sportradarEnabled"
    />
    <integration-card :integration="Integrations.meta" v-if="metaEnabled" />
    <integration-card
      v-if="googleAdsEnabled"
      :integration="Integrations.googleads"
    />
    <integration-card
      v-for="(dynamicIntegration, index) in dynamicIntegrations"
      :key="index"
      :integration="Integrations.dynamicpromotions"
      :dynamic-integration="dynamicIntegration"
    />
    <integration-card :integration="Integrations.alira" />
    <integration-card :integration="Integrations.gig" v-if="gigEnabled" />
    <integration-card :integration="Integrations.igt" v-if="igtEnabled" />
    <integration-card :integration="Integrations.openbet" v-if="showOpenBet" />
    <integration-card
      :integration="Integrations.opapwebhook"
      v-if="showOpapWebhook"
    />
    <integration-card :integration="Integrations.otp" />
    <integration-card v-if="warplyEnabled" :integration="Integrations.warply" />
  </el-row>
</template>

<script>
import { $hasFeature } from '@/core/utils/VueAcl'
import IntegrationCard from '@/modules/integrations/components/IntegrationCard'
import Integrations from '@/modules/integrations/types'
import RestApi from '@/core/services/RestApi'

export default {
  name: 'IntegrationsMarketplace',

  components: {
    IntegrationCard
  },

  data() {
    return {
      Integrations,
      dynamicIntegrations: []
    }
  },

  mounted() {
    this.fetchDynamicIntegrations()
  },

  computed: {
    showBetsson() {
      return $hasFeature('betssonIntegration')
    },
    showOasis() {
      return $hasFeature('oasisIntegration')
    },
    showLithium() {
      return $hasFeature('showLithiumIntegration')
    },
    showLithiumV2() {
      return $hasFeature('showLithiumV2Integration')
    },
    showOpenBet() {
      return $hasFeature('showOpenBetIntegration')
    },
    showOpapWebhook() {
      return $hasFeature('opapWebhookIntegration')
    },
    sportradarEnabled() {
      return this.$store.state.app.features.sportradar
    },
    metaEnabled() {
      return this.$store.state.app.features.meta
    },
    googleAdsEnabled() {
      return this.$store.state.app.features.googleads
    },
    gigEnabled() {
      return this.$store.state.app.features.gigIntegration
    },
    igtEnabled() {
      return this.$store.state.app.features.igtIntegration
    },
    warplyEnabled() {
      return this.$store.state.app.features.warplyIntegration
    }
  },
  methods: {
    async fetchDynamicIntegrations() {
      let projectId = window.xp.project.id
      const result = await RestApi.get(
        `projects/${projectId}/integrations/dynamic-promotions`
      )
      this.dynamicIntegrations = result['data']
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/pages/IntegrationsMarketplace.vue